import { createAsyncThunk } from '@betty/toolkit/state';
import DocsService from '../services/DocsService/DocsService';

export const uploadKYCDocs = createAsyncThunk(
  'onboarding/uploadKYCDocs',
  async (data: FormData) => await DocsService.uploadKYCDocs({ data }),
);
